<template>
  <div class="nav-menu nav-menu-activity">
    <div class="nav-menu-inner app-basic-layout-wrapper">
      <div class="main-wrapper">
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-shangyehezuo"></i>
            <h3 class="group-title">商业合作</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://www.weibo.com/u/6186574130"
                  target="_blank"
                  @click="doStat('top_nav_tw')"
                >
                  微博台网
                </a>
              </li>
              <li>
                <a
                  href="https://hd.weibo.com/hotpoint/list"
                  target="_blank"
                  @click="doStat('top_nav_hotpoint')"
                >
                  微博热点营销项目
                </a>
              </li>
              <li>
                <a
                  href="https://mcn.weibo.com/introduce"
                  target="_blank"
                  @click="doStat('top_nav_mcn')"
                >
                  MCN机构
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="nav-group">
          <div class="group-header">
            <i class="iconfont icon-jinqihuodongxiangmu"></i>
            <h3 class="group-title">近期活动项目</h3>
          </div>
          <div class="group-body">
            <ul class="submenu-list">
              <li>
                <a
                  href="https://huodong.weibo.com/netstar2021/index"
                  target="_blank"
                  @click="doStat('top_nav_netstar2021')"
                >
                  2021超级红人节
                </a>
              </li>
              <li>
                <a
                  href="/topic/view/266"
                  target="_blank"
                  @click="doStat('top_nav_zbc')"
                >
                  针不戳品牌V+计划
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="extra-wrapper nav-group">
        <div class="group-header">
          <i class="iconfont icon-jingxuan"></i>
          <h3 class="group-title">精选内容</h3>
        </div>
        <div class="group-body">
          <a
            href="/topic/view/266"
            class="extra-item"
            target="_blank"
            @click="doStat('top_nav_banner_activity')"
          >
            <div class="poster">
              <img
                src="https://static.hd.weibo.com/marketing/static/img/9875825c-8f2d-4ea3-8f34-2d3c33e29b86.png"
                alt=""
              />
            </div>
            <h4>昙花一现的都是流量，针不戳的才是品牌</h4>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    doStat(module) {
      if (module) {
        this.$stat({
          key: 'nav_click',
          params: { module },
          pathName: this.$route.name
        })
      }
    }
  }
}
</script>
